import { UseFormReturnType } from '@mantine/form'
import SelectWithPagination from '@v2/commons/components/SelectWithPagination/SelectWithPagination.component'
import useGetBenefitsByAbcs from '@v2/commons/hooks/benefitsByAbcs/useGetBenefitByAbcIds.hook'

import { MutateEscalationData } from '../../escalation.types'

interface BenefitSectionForm {
  abc: string
  form: UseFormReturnType<MutateEscalationData>
}

const BenefitSection = ({ abc, form }: BenefitSectionForm) => {
  const { benefitsOptions, handlePaginate, searchForm } = useGetBenefitsByAbcs(
    abc,
    form.getValues()['benefit']?.name,
  )
  const handleDebounceSearch = (search: string) => {
    searchForm.setValue(search)
  }
  const getInitalBenefitValue = () => {
    return benefitsOptions?.find(
      ({ value }) => value === form.getValues()['benefitId'],
    )?.label
  }
  return (
    <>
      {benefitsOptions && (
        <SelectWithPagination
          options={benefitsOptions}
          label="Benefit / Service"
          required
          handleSearch={handleDebounceSearch}
          onOptionSelect={(value: string) =>
            form.setFieldValue('benefitId', value)
          }
          handlePaginate={handlePaginate}
          initialValue={getInitalBenefitValue()}
        />
      )}
    </>
  )
}

export default BenefitSection
